import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { DesignerComponent } from './components/organization/captive-portal/cp-designer/designer.component';
import { CpAddUpdateComponent } from './components/organization/captive-portal/cp-add-update/cp-add-update.component';
import { LocalesComponent } from './components/organization/captive-portal/locales/locales.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { RouterConst } from './globals/RoutersConst';
import { Authentication, Authentication4Login } from './auth/Authentication';
import { DashboardComponent } from './components/dashboards/key-user-metrics/key-user-metrics.component';
import { ChartsAndSummaryComponent } from './components/dashboards/charts-and-summary/charts-and-summary.component';
import { LocationSetupComponent } from './components/organization/location-setup/location-setup.component';
import { AnalyticsUsersComponent } from './components/organization/analytics-users/analytics-users.component';
import { SecurityGroupsComponent } from './components/organization/security-groups/security-groups.component';
import { AnalyticsEmailAccountsComponent } from './components/organization/accounts/email-accounts/email-accounts.component';
import { AnalyticsSmsAccountsComponent } from './components/organization/accounts/sms-accounts/sms-accounts.component';
import { AnalyticsPaypalAccountsComponent } from './components/organization/accounts/paypal-accounts/paypal-accounts.component';
import { AnalyticsGoogleAccountsComponent } from './components/organization/accounts/google-accounts/google-accounts.component';
import { AnalyticsPaypalOptionsComponent } from './components/organization/accounts/paypal-options/paypal-options.component';
import { AnalyticsFacebookAccountsComponent } from './components/organization/accounts/facebook-accounts/facebook-accounts.component';
import { AnalyticsTwitterAccountsComponent } from './components/organization/accounts/twitter-accounts/twitter-accounts.component';
import { AnalyticsVouchersComponent } from './components/organization/accounts/vouchers/vouchers.component';
import { AnalyticsMailchimpAccountsComponent } from './components/organization/accounts/mailchimp-accounts/mailchimp-accounts.component';
import { ActiveSessionsComponent } from './components/sessions/active-sessions/active-sessions.component';
import { SessionsStatComponent } from './components/sessions/sessions-stat/sessions-stat.component';
import { CountriesComponent } from './components/organization/vocabularies/countries/countries.component';
import { CpCodesComponent } from './components/organization/vocabularies/cp-codes/cp-codes.component';
import { ChangeLogComponent } from './components/organization/change-log/change-log.component';
import { ClientsComponent } from './components/admin/clients/clients.component';
import { SessionSummaryComponent } from './components/dashboards/reporting/session-summary/session-summary.component';
import { LoginHistoryComponent } from './components/organization/login-history/login-history.component';
import { UsersComponent } from './components/users/users.component';
import { SessionsComponent } from './components/usage_statistics/sessions/sessions.component';
import { DataComponent } from './components/usage_statistics/data/data.component';
import { LoginMethodComponent } from './components/usage_statistics/login-method/login-method.component';
import { RedirectStrategiesComponent } from './components/organization/captive-portal/redirect-strategies/redirect-startegies.component';
import { LocationGroupsComponent } from './components/organization/location-groups/location-groups.component';
import { NotLoggedInUsersComponent } from './components/dashboards/reporting/not-logged-in-users/not-logged-in-users.component';
import { ForgetUserComponent } from './components/admin/forget-user/forget-user.component';
import { MessagingStrategiesComponent } from './components/organization/captive-portal/messaging-strategies/messaging-strategies.component';
import { DynamicImagesComponent } from './components/organization/captive-portal/dynamic-images/dynamic-images.component';
import { ImageUploaderComponent } from './components/organization/captive-portal/image-uploader/image-uploader.component';
import { BackgroundUploaderComponent } from './components/organization/captive-portal/background-uploader/background-uploader.component';
import { FontsUploaderComponent } from './components/organization/captive-portal/fonts-uploader/fonts-uploader.component';
import { TermsBuilderComponent } from './components/organization/captive-portal/terms-builder/terms-builder.component';
import { SessionDetailReportComponent } from './components/dashboards/reporting/session-detail-report/session-detail-report.component';
import { SmsAccountingComponent } from './components/dashboards/reporting/sms-accounting/sms-accounting.component';
import { AnalyticsWiredMessengerAccountsComponent } from './components/organization/accounts/wired-messenger-accounts/wired-messenger-accounts.component';
import { RegionsComponent } from './components/organization/regions/regions.component';
import { OptInComponent } from './components/dashboards/reporting/opt-in/opt-in.component';
import {SentMessagesComponent} from "./components/dashboards/reporting/sent-messages/sent-messages.component";
import {AppPrivacyComponent} from "./app.privacy.component";

export const routes: Routes = [
  // { path: '', redirectTo: RouterConst.LOGIN, pathMatch: 'full' },
  { path: '', component: LoginComponent, canActivate: [Authentication4Login], pathMatch: 'full' },
  { path: 'legal/privacy', component: AppPrivacyComponent},
  {
    path: RouterConst.LOGIN,
    component: LoginComponent,
    canActivate: [Authentication4Login],
  },
  {
    path: RouterConst.MAIN,
    component: MainComponent,
    canActivate: [Authentication],
    children: [
      {
        path: RouterConst.DASHBOARD,
        component: DashboardComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ADD_UPDATE,
        component: CpAddUpdateComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.REDIRECT_CHANGES,
        component: RedirectStrategiesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.MESSAGING_STRATEGIES,
        component: MessagingStrategiesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.DYNAMIC_IMAGES,
        component: DynamicImagesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.IMAGE_UPLOADER,
        component: ImageUploaderComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.BACKGROUND_UPLOADER,
        component: BackgroundUploaderComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.FONTS_UPLOADER,
        component: FontsUploaderComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.TERMS_BUILDER,
        component: TermsBuilderComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.CHARTS,
        component: ChartsAndSummaryComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOCATION_SETUP,
        component: LocationSetupComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOCATION_REGIONS,
        component: RegionsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOCATION_GROUPS,
        component: LocationGroupsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_USERS,
        component: AnalyticsUsersComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_GROUPS,
        component: SecurityGroupsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_EMAIL_ACCOUNTS,
        component: AnalyticsEmailAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_SMS_ACCOUNTS,
        component: AnalyticsSmsAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_PAYPAL_ACCOUNTS,
        component: AnalyticsPaypalAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_GOOGLE_ACCOUNTS,
        component: AnalyticsGoogleAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_PAYPAL_OPTIONS,
        component: AnalyticsPaypalOptionsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_FACEBOOK_ACCOUNTS,
        component: AnalyticsFacebookAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_TWITTER_ACCOUNTS,
        component: AnalyticsTwitterAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_MAILCHIMP_ACC,
        component: AnalyticsMailchimpAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_VOUCHERS,
        component: AnalyticsVouchersComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_MAILCHIMP_ACC,
        component: AnalyticsMailchimpAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ANALYTICS_WIRED_MESSENGER_ACC,
        component: AnalyticsWiredMessengerAccountsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOCALES,
        component: LocalesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSIONS_ACTIVE_SESSIONS,
        component: ActiveSessionsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSIONS_SESSION_STAT,
        component: SessionsStatComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.COUNTRIES,
        component: CountriesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.CP_CODES,
        component: CpCodesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.ADMIN_CLIENTS,
        component: ClientsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.USERS,
        component: UsersComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSIONS,
        component: SessionsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.DATA,
        component: DataComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOGIN_METHOD,
        component: LoginMethodComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.USERS,
        component: UsersComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSIONS,
        component: SessionsComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.DATA,
        component: DataComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOGIN_METHOD,
        component: LoginMethodComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.CHANGE_LOG,
        component: ChangeLogComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSION_SUMMARY,
        component: SessionSummaryComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.NOT_LOGGED_IN_USERS,
        component: NotLoggedInUsersComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.LOGIN_HISTORY,
        component: LoginHistoryComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.DESIGNER,
        component: DesignerComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.FORGET_USER,
        component: ForgetUserComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SESSION_DETAIL_REPORT,
        component: SessionDetailReportComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SMS_ACCOUNTING,
        component: SmsAccountingComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.OPT_IN_USERS,
        component: OptInComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
      {
        path: RouterConst.SENT_MESSAGES,
        component: SentMessagesComponent,
        outlet: 'sub',
        canActivate: [Authentication],
      },
    ],
  },
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/app.routes.ts